import { GroupableTags } from '@components/TagDialog/TagDialog.types';
import { checkDevice } from '@store/redux/features/mobile/mobileSelectors';
import { getDefaultTagBackground, getTagFontColor } from '@utils';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import {
  TagContainer,
  TagLine,
  TagsRight,
  TagsRow,
} from '../../Updates.styles';
import { DivFwd, HovercardDivProps } from './RelatedTagsList.types';

function FWRelatedTagsList(props: RelatedTagsListProps, ref: DivFwd) {
  const { tags, ...rest } = props;
  const { className } = rest;
  const { isMobile } = useSelector(checkDevice());

  let tagsRowClassName: string | undefined;
  if (className?.includes('TagsList_responsive')) {
    tagsRowClassName = 'TagsList_responsive';
  }
  // Only enable for inventory tags list.
  const responsive = tagsRowClassName && isMobile;

  return (
    <TagLine ref={ref} {...rest}>
      <TagsRight />
      <TagsRow className={tagsRowClassName}>
        {tags.map(tag => {
          return (
            <TagContainer
              // Pass a unique key
              text={responsive ? 'p100' : 'b200'}
              bg={getDefaultTagBackground(tag.color)}
              key={tag.id}
              c={getTagFontColor(tag.color)}
            >
              {tag.tagName}
            </TagContainer>
          );
        })}
      </TagsRow>
    </TagLine>
  );
}

interface RelatedTagsListProps extends HovercardDivProps {
  tags: GroupableTags[];
}
/**
 *
 * Note: If The fade effect looks weird, change the color faded to by defining a `--parent-bg` higher up or on this component
 *
 * @example
 *  ```css
 *  --parent-bg: #fff;
 * ```
 *
 * Or, see `TagsRight` component used in this component.
 *
 *  *
 * # Note:
 *
 * This does not support the global transition on the app, so to fix this you can manually style `TagRight` on hover.
 *
 */
export const RelatedTagsList = forwardRef(FWRelatedTagsList);
